import { mergeMap } from "rxjs";
import { Injectable } from '@angular/core';
import { Action, Selector, State, Store, type StateContext } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import { UserSharedActions } from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';
import { NavigationControlState, UserEntityState } from '../../internal';

export interface UserSharedStateModel {
  usersLoaded: boolean;
}

@State<UserSharedStateModel>({
  name: 'userShared',
  defaults: {
    usersLoaded: false,
  }
})
@Injectable()
export class UserSharedState {
  constructor(public store: Store,
              public apiControlService: ApiControlService) {
  }

  //<editor-fold desc="Selectors">

  @Selector([
    UserEntityState.typedEntities$,
    NavigationControlState.userIdSlug$,
  ])
  static user$(typedEntities: { [id: string]: FlatModels.UserEntityModels.User },
               userId: string | null) {
    return typedEntities && userId && typedEntities[userId] || null;
  }

  //</editor-fold>


  //<editor-fold desc="Actions">
  
  @Action(UserSharedActions.GetUsersSuccess)
  getUsersSuccess({patchState}: StateContext<UserSharedStateModel>) {
    patchState({
      usersLoaded: true
    });
  }

  @Action(UserSharedActions.GetUsers)
  getUsers({getState}: StateContext<UserSharedStateModel>) {
    if (getState().usersLoaded) {
      return;
    }
    return this.apiControlService.sendMessage(
      new UserSharedActions.GetUsersRequest()
    ).pipe(
      mergeMap(() =>
        this.store.dispatch(new UserSharedActions.GetUsersSuccess())
      ),
    );
  }

  //</editor-fold>
}
